// extracted by mini-css-extract-plugin
module.exports = {"icon-rouble":"select_icon-rouble__3VtDH","rouble":"select_rouble__2WC9N","select":"select_select__10X2C","Select-animation-fadeIn":"select_Select-animation-fadeIn___2mZa"};